import React, { useEffect } from 'react';
import { TrainingHero } from '../components/Training/TrainingHero';
import { ScrollingTagline } from '../components/Training/ScrollingTagline';
import { TrainingGalleryStrip } from '../components/Training/TrainingGalleryStrip';
import { TrainingPositioning } from '../components/Training/TrainingPositioning';
import { TrainingAreas } from '../components/Training/TrainingAreas';
import { SignaturePrograms } from '../components/Training/SignaturePrograms';
import { TrainingFormats } from '../components/Training/TrainingFormats';
import { TrainingPackages } from '../components/Training/TrainingPackages';
import { WhoWeTrain } from '../components/Training/WhoWeTrain';
import { TrainingCommunity } from '../components/Training/TrainingCommunity';
import { TrainingProposalForm } from '../components/Training/TrainingProposalForm';
import { TrainingCTA } from '../components/Training/TrainingCTA';
import { createScrollObserver } from '../utils/animations';
export const Training = () => {
  useEffect(() => {
    // Initialize scroll animations
    const observer = createScrollObserver(entry => {
      entry.target.classList.add('animate-in');
    });
    if (observer) {
      document.querySelectorAll('.scroll-animate').forEach(el => {
        observer.observe(el);
      });
    }
    return () => observer?.disconnect();
  }, []);
  return <div className="overflow-hidden bg-white" data-id="element-4871">
      <TrainingHero data-id="element-4872" />
      <ScrollingTagline data-id="element-4873" />
      <TrainingGalleryStrip data-id="element-4874" />
      <TrainingPositioning data-id="element-4875" />
      <TrainingAreas data-id="element-4876" />
      <SignaturePrograms data-id="element-4877" />
      <TrainingFormats data-id="element-4878" />
      <TrainingPackages data-id="element-4879" />
      <WhoWeTrain data-id="element-4880" />
      <TrainingCommunity data-id="element-4881" />
      <TrainingProposalForm data-id="element-4882" />
      <TrainingCTA data-id="element-4883" />
    </div>;
};